export default "__VITE_ASSET__3d031fce__"